import TableCommon from "../../../../components/Common/TableCommon";
import { NoData, TabPoolsContainer } from "../../Liquidity/Tabs/Pools/styled";
import { useContext, useEffect, useState } from "react";
import { ContextProviderWrapper } from "../../../../components/Context";
import { PoolsStaking } from "./styled";
import ModalOverlay from "../../../../components/Common/ModalOverlay";
import LiveStake from "./Stake";
import LiveUnstake from "./Unstake";
import { useAppKitAccount } from "@reown/appkit/react";
import web3 from "web3";
import  ABI_STAKING  from "../../../../constant/ABI/abiStaking.json";
import LiveSchedule from "./Shedule";
import LiveItem from "./Item";
import { useUserStakingInfo } from "../../../../hooks/useUserStakingInfo";

const StakingLive = ({ filteredPools, searchValue, dataPools }: any) => {
  const Web3 = new web3(window.ethereum);
  const { theme } = useContext(ContextProviderWrapper)!;
  const { address }: any = useAppKitAccount();

  const { userProfile, tokenPrices, fetchUserProfile, fetchPrices }: any =
    useUserStakingInfo(address, dataPools);

  const [openStake, setOpenStake] = useState(false);
  const [openUnStake, setOpenUnStake] = useState(false);
  const [openSchedule, setOpenSchedule] = useState(false);
  const [expandedRows, setExpandedRows] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [clickedId, setClickedId] = useState(0);

  const [listSchedule, setListSchedule] = useState([]);

  const handleGetPool = (record: any) => {
    setExpandedRows((prev) => ({
      ...prev,
      [record.id]: !prev[record.id],
    }));
    setClickedId(record.id);
  };

  const headingData = [
    {
      name: "",
      dataIndex: "",
      key: "",
      render: ({ token0, token1, term, id, aprDummy }: any) => {
        const isExpanded = expandedRows[id];
        return (
          <LiveItem
            displayData={displayData}
            isExpanded={isExpanded}
            id={id}
            token0={token0}
            token1={token1}
            term={term}
            aprDummy={aprDummy}
            setOpenStake={setOpenStake}
            setOpenUnStake={setOpenUnStake}
            setOpenSchedule={setOpenSchedule}
            setClickedId={setClickedId}
            tokenPrices={tokenPrices}
            fetchPrices={fetchPrices}
            fetchUserProfile={fetchUserProfile}
            userProfile={userProfile}
          />
        );
      },
    },
  ];

  const displayData =
    (filteredPools && filteredPools.length > 0) || searchValue
      ? filteredPools
      : dataPools;

  const handleGetSchedule = async () => {
    const contract = new Web3.eth.Contract(
      ABI_STAKING,
      displayData[clickedId - 1]?.contract
    );
    contract.methods
      .getUserStakedCount(address)
      .call()
      .then(async (resStakedCount: any) => {
        if (resStakedCount !== "0") {
          let arrData = [];
          for (let i = 0; i < parseInt(resStakedCount); i++) {
            arrData.push(contract.methods.stakeDetails(address, i).call());
          }
          try {
            const listData: any = await Promise.all(arrData);
            const sortedListData = listData.sort((a: any, b: any) => {
              const startBlockA = BigInt(a.startStakeBlock);
              const startBlockB = BigInt(b.startStakeBlock);
              return startBlockB > startBlockA
                ? 1
                : startBlockB < startBlockA
                ? -1
                : 0;
            });
            setListSchedule(sortedListData);
          } catch (error) {
            console.error("Error fetching stake details:", error);
          }
        } else {
          setListSchedule([]);
        }
      })
      .catch((error:any) => {
        console.error("Error fetching user staked count:", error);
      });
  };

  useEffect(() => {
    if (address && clickedId > 0) {
      handleGetSchedule();
    }
  }, [address, clickedId]);

  return (
    <TabPoolsContainer className="staking-container">
      {/* Modal Schedule */}
      <ModalOverlay
        component={
          <LiveSchedule listSchedule={listSchedule} clickedId={clickedId} />
        }
        open={openSchedule}
        setOpen={setOpenSchedule}
        title={"Schedule"}
        width="500px"
      />
      {/* ----------- */}
      {/* Modal stake */}
      <ModalOverlay
        component={
          <LiveStake
            fetchUserProfile={fetchUserProfile}
            fetchPrices={fetchPrices}
            displayData={displayData}
            clickedId={clickedId}
            openStake={openStake}
            setOpenStake={setOpenStake}
            handleGetSchedule={handleGetSchedule}
          />
        }
        open={openStake}
        setOpen={setOpenStake}
        title={"Stake In Pool"}
        width="400px"
      />
      {/* ----------- */}
      {/* Modal unstake */}
      <ModalOverlay
        component={
          <LiveUnstake
            displayData={displayData}
            clickedId={clickedId}
            setOpenUnStake={setOpenUnStake}
            userProfile={userProfile}
            fetchUserProfile={fetchUserProfile}
            fetchPrices={fetchPrices}
          />
        }
        open={openUnStake}
        setOpen={setOpenUnStake}
        title={"Unstake in pool"}
        width="400px"
      />
      {/* ----------- */}
      <PoolsStaking>
        {displayData?.length > 0 ? (
          <TableCommon
            data={displayData}
            heading={headingData}
            pagination={false}
            callback={handleGetPool}
            className="table-pools-staking"
          />
        ) : (
          <NoData className={theme}>
            <img src="/static/img-nodata.png" alt="No Data" />
            <p className="title-nodata">No data</p>
            <p className="text-nodata">There isn't pool staking now</p>
          </NoData>
        )}
      </PoolsStaking>
    </TabPoolsContainer>
  );
};

export default StakingLive;
